import { useCallback } from 'react'

// utils
import { 
  getDishContract, 
  getDishMasterContract, 
  // approveERC721,
  setApprovalForAll,
  getBakerySoccerMasterAddress,
  getBakerySoccerContract,
  getSoccerPokerGameBoxContract,
  getSoccerPokerGameBoxMasterContract,
  getSoccerPokerGameBoxBurnByProxyContract,
  getComboNFTCommonStakeERC721EarnBake2Contract,
  getComboNFTCommonStakeERC721EarnBake3Contract
 } from '../../sushi/utils'


// hooks
import useYam from '../bakery/useYam'
import { useActiveWeb3React } from '../'
import { NFTTYPE } from '../../constants/bakery/nft'

const useApproveNFT = (tokenId: string, type?: string) => {
  const { account } = useActiveWeb3React()
  const sushi = useYam()
  let erc721Contract = getDishContract(sushi)
  let dishMasterContract = getDishMasterContract(sushi)
  switch (type) {
    case NFTTYPE.COMBO_V2:
      dishMasterContract = getComboNFTCommonStakeERC721EarnBake2Contract(sushi)
      break
    case NFTTYPE.COMBO_V3:
      dishMasterContract = getComboNFTCommonStakeERC721EarnBake3Contract(sushi)
      break
    case NFTTYPE.SOCCER:
      erc721Contract = getBakerySoccerContract(sushi)
      dishMasterContract = getBakerySoccerMasterAddress(sushi)
      break
    case NFTTYPE.GAMEBOX:
      erc721Contract = getSoccerPokerGameBoxContract(sushi)
      dishMasterContract = getSoccerPokerGameBoxMasterContract(sushi)
      break
    case 'GAMEBOXBURN':
      erc721Contract = getSoccerPokerGameBoxContract(sushi)
      dishMasterContract = getSoccerPokerGameBoxBurnByProxyContract(sushi)
      break
  }

  const handleApprove = useCallback(async (type?: string) => {
    try {
      if(type === 'DECOMPOSE'){
        erc721Contract = getDishContract(sushi)
        dishMasterContract = getDishMasterContract(sushi)
      }
      let tx = await setApprovalForAll(erc721Contract, dishMasterContract, account)
      return tx
    } catch (e) {
      return false
    }
  }, [account, erc721Contract, dishMasterContract, tokenId])

  return { onApprove: handleApprove }
}

export default useApproveNFT
